// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("Fonts/OpenSans.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./Fonts/Rubik/static/Rubik-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: 'Rubik';
  background-color: #f5f6f6;
  margin: 0;
  padding: 0;
}

.app-container {
  text-align: center;
}

.main-title {
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
}

.subtitle {
  font-size: 1.25rem;
  margin-bottom: 2rem;
}

.main-content {
  margin-top: 15rem;
}
@font-face {
  font-family: 'OpenSans';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'Rubik';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}
.mobile-warning {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #3c4f58;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  z-index: 9999;
}

.mobile-warning-content {
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  text-align: center;
  max-width: 90%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.mobile-warning-content h1 {
  color: #3c4f58;
  font-size: 1.5rem;
  margin-bottom: 20px;
  font-weight: bold;
}

.mobile-warning-content p {
  color: #666;
  margin-bottom: 10px;
  font-size: 1rem;
  line-height: 1.5;
}
.warning-logo-top {
  width: 80px;
  height: auto;
  margin-bottom: 20px;
  display: block; /* Block element olarak ayarla */
  margin-left: auto; /* Sağdan ve soldan otomatik margin */
  margin-right: auto;
}

.hover\\:bg-blue-100:hover {
  background-color: #dbeafe;
}

.hover\\:bg-blue-700:hover {
  background-color: #1d4ed8;
}

.hover\\:text-gray-700:hover {
  color: #4a5568;
}

.transition {
  transition: all 0.3s ease;
}

.cursor-pointer {
  cursor: pointer;
}

.pointer-events-none {
  pointer-events: none;
}


.border {
  border-width: 1px;
  border-style: solid;
}

.border-gray-300 {
  border-color: #d1d5db;
}

.border-gray-400 {
  border-color: #cbd5e1;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,+DAAiD;EACjD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,+DAAqE;AACvE;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc,EAAE,gCAAgC;EAChD,iBAAiB,EAAE,qCAAqC;EACxD,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;;AAGA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["body {\r\n  font-family: 'Rubik';\r\n  background-color: #f5f6f6;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.app-container {\r\n  text-align: center;\r\n}\r\n\r\n.main-title {\r\n  font-size: 2.5rem;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.subtitle {\r\n  font-size: 1.25rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.main-content {\r\n  margin-top: 15rem;\r\n}\r\n@font-face {\r\n  font-family: 'OpenSans';\r\n  src: url('Fonts/OpenSans.ttf') format('truetype');\r\n  font-weight: 400;\r\n  font-style: normal;\r\n}\r\n\r\n@font-face {\r\n  font-family: 'Rubik';\r\n  src: url('./Fonts/Rubik/static/Rubik-Regular.ttf') format('truetype');\r\n}\r\n.mobile-warning {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: #3c4f58;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 20px;\r\n  z-index: 9999;\r\n}\r\n\r\n.mobile-warning-content {\r\n  background-color: white;\r\n  padding: 30px;\r\n  border-radius: 12px;\r\n  text-align: center;\r\n  max-width: 90%;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.mobile-warning-content h1 {\r\n  color: #3c4f58;\r\n  font-size: 1.5rem;\r\n  margin-bottom: 20px;\r\n  font-weight: bold;\r\n}\r\n\r\n.mobile-warning-content p {\r\n  color: #666;\r\n  margin-bottom: 10px;\r\n  font-size: 1rem;\r\n  line-height: 1.5;\r\n}\r\n.warning-logo-top {\r\n  width: 80px;\r\n  height: auto;\r\n  margin-bottom: 20px;\r\n  display: block; /* Block element olarak ayarla */\r\n  margin-left: auto; /* Sağdan ve soldan otomatik margin */\r\n  margin-right: auto;\r\n}\r\n\r\n.hover\\:bg-blue-100:hover {\r\n  background-color: #dbeafe;\r\n}\r\n\r\n.hover\\:bg-blue-700:hover {\r\n  background-color: #1d4ed8;\r\n}\r\n\r\n.hover\\:text-gray-700:hover {\r\n  color: #4a5568;\r\n}\r\n\r\n.transition {\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.cursor-pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n.pointer-events-none {\r\n  pointer-events: none;\r\n}\r\n\r\n\r\n.border {\r\n  border-width: 1px;\r\n  border-style: solid;\r\n}\r\n\r\n.border-gray-300 {\r\n  border-color: #d1d5db;\r\n}\r\n\r\n.border-gray-400 {\r\n  border-color: #cbd5e1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
